import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Zap, Eye, EyeOff } from 'lucide-react';

export default function Login() {
  const [form, setForm] = useState({ username: '', password: '' });
  const [showPwd, setShowPwd] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const handle = async (e) => {
    e.preventDefault();
    setLoading(true); setError('');
    try {
      await login(form.username, form.password);
      navigate('/');
    } catch (err) {
      const msg = err?.response?.data?.error;
      setError(msg || 'Usuário ou senha inválidos');
    } finally {
      setLoading(false);
    }
  };

  const S = {
    page: {
      minHeight:'100vh', display:'flex', alignItems:'center', justifyContent:'center',
      background:'radial-gradient(ellipse at 20% 50%, #1a1500 0%, #080c14 60%)',
    },
    card: {
      width:380, background:'#0e1420', borderRadius:16,
      border:'1px solid #1a2035', padding:'40px 36px',
      boxShadow:'0 24px 80px rgba(0,0,0,0.6)',
    },
    logo: { textAlign:'center', marginBottom:36 },
    logoIcon: {
      width:56, height:56, borderRadius:14,
      background:'linear-gradient(135deg,#f6c90e,#e8a800)',
      display:'flex', alignItems:'center', justifyContent:'center',
      margin:'0 auto 12px',
    },
    title: { fontSize:22, fontWeight:800, color:'#f6c90e', letterSpacing:-0.5 },
    sub: { fontSize:12, color:'#475569', marginTop:4 },
    label: { display:'block', fontSize:11, color:'#64748b', marginBottom:6, textTransform:'uppercase', letterSpacing:1 },
    inputWrap: { position:'relative', marginBottom:18 },
    input: {
      width:'100%', padding:'11px 14px', borderRadius:8,
      background:'#0f1117', border:'1px solid #1a2035', color:'#e2e8f0',
      fontSize:14, outline:'none', transition:'border 0.15s',
    },
    eyeBtn: {
      position:'absolute', right:12, top:'50%', transform:'translateY(-50%)',
      background:'none', border:'none', cursor:'pointer', color:'#475569',
      display:'flex', alignItems:'center',
    },
    btn: {
      width:'100%', padding:'12px', borderRadius:8, border:'none',
      background:'linear-gradient(135deg,#f6c90e,#e8a800)',
      color:'#080c14', fontSize:14, fontWeight:700, cursor:'pointer',
      marginTop:8, transition:'opacity 0.15s',
    },
    error: {
      background:'rgba(248,113,113,0.1)', border:'1px solid rgba(248,113,113,0.3)',
      borderRadius:8, padding:'10px 14px', color:'#f87171',
      fontSize:13, marginBottom:16,
    },
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}>
          <div style={S.logoIcon}><Zap size={28} color="#080c14" /></div>
          <div style={S.title}>CRM Solar</div>
          <div style={S.sub}>Sistema de Gestão Solar</div>
        </div>

        <form onSubmit={handle}>
          <div style={S.inputWrap}>
            <label style={S.label}>Usuário</label>
            <input
              style={S.input}
              value={form.username}
              onChange={e => setForm(f => ({ ...f, username: e.target.value }))}
              placeholder="seu.usuario"
              autoCapitalize="none"
              autoCorrect="off"
              autoComplete="username"
              spellCheck={false}
              required
            />
          </div>
          <div style={S.inputWrap}>
            <label style={S.label}>Senha</label>
            <input
              style={{ ...S.input, paddingRight: 44 }}
              type={showPwd ? 'text' : 'password'}
              value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••"
              required
            />
            <button type="button" style={S.eyeBtn} onClick={() => setShowPwd(s => !s)}>
              {showPwd ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          {error && <div style={S.error}>{error}</div>}

          <button style={{ ...S.btn, opacity: loading ? 0.7 : 1 }} disabled={loading}>
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}
